module.exports = __webpack_public_path__ + "static/media/readering-course.06deb522.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/index/readering-course.png
// module id = 233
// module chunks = 1